import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-aftale-nav',
    templateUrl: './aftale-nav.component.html',
    styleUrls: ['./aftale-nav.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AftaleNavComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
